import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list", "template", "item"];
  static values = { duration: { type: Number, default: 8000 } };

  initialize() {
    this.timers = new Map();
  }

  disconnect() {
    this.timers.forEach((timer) => clearTimeout(timer));
    this.timers.clear();
  }

  itemTargetConnected(item) {
    item.dataset.toastKey ||= `${item.dataset.kind}:${item.querySelector("[data-toast-message]").textContent.trim()}`;
    this.element.scrollTop = this.element.scrollHeight;
    this.schedule(item);
  }

  itemTargetDisconnected(item) {
    this.cancel(item);
  }

  show({ detail }) {
    const { message, kind = "success", id } = detail || {};
    if (typeof message !== "string" || !message.trim() || !["success", "error"].includes(kind)) return;

    const key = typeof id === "string" && id ? id : `${kind}:${message.trim()}`;
    const existing = this.itemTargets.find((item) => item.dataset.toastKey === key);
    const item = existing || this.templateTarget.content.firstElementChild.cloneNode(true);
    const text = item.querySelector("[data-toast-message]");

    item.dataset.toastKey = key;
    item.dataset.kind = kind;
    text.setAttribute("role", kind === "error" ? "alert" : "status");
    text.textContent = message.trim();
    item.open = true;

    if (existing) this.schedule(item);
    else this.listTarget.append(item);
  }

  toggled({ currentTarget: item }) {
    if (!item.open) item.remove();
  }

  pause({ currentTarget: item }) {
    this.cancel(item);
  }

  resume({ currentTarget: item, relatedTarget }) {
    if (!item.contains(relatedTarget)) this.schedule(item);
  }

  visibilityChanged() {
    this.itemTargets.forEach((item) => this.schedule(item));
  }

  schedule(item) {
    this.cancel(item);
    if (
      item.dataset.kind === "error" ||
      document.hidden ||
      item.matches(":hover") ||
      item.contains(document.activeElement)
    )
      return;

    this.timers.set(
      item,
      setTimeout(() => {
        this.timers.delete(item);
        item.remove();
      }, this.durationValue)
    );
  }

  cancel(item) {
    clearTimeout(this.timers.get(item));
    this.timers.delete(item);
  }
}
